import { render, staticRenderFns } from "./AdditionalsSidebarMenu.vue?vue&type=template&id=610d11b1&scoped=true&"
import script from "./AdditionalsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalsSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d11b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610d11b1')) {
      api.createRecord('610d11b1', component.options)
    } else {
      api.reload('610d11b1', component.options)
    }
    module.hot.accept("./AdditionalsSidebarMenu.vue?vue&type=template&id=610d11b1&scoped=true&", function () {
      api.rerender('610d11b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/AdditionalsSidebarMenu.vue"
export default component.exports